import './App.css';
import { ConfigProvider, theme } from 'antd';
import LoanApp from './components/LoanApp';
import './theme.less';
const { darkAlgorithm } = theme;

//<TestVtk/>
function App() {
  return (
    <LoanApp/>  
  );
}

export default App;
